import { IGameScreen } from '@/interface/game';
import ElementsPreview from '../Canvas/Elements/ElementsPreview';
import LeadScreen from './LeadScreen/LeadScreen';
import { useCanvasResize } from '@/hooks/useResizeCanvas';

type GameStartScreenProps = {
  screen: IGameScreen;
  gameId: string;
  onSetScreen: (a: string) => void;
};
const GameScreen = ({ screen, gameId, onSetScreen }: GameStartScreenProps) => {
  useCanvasResize();

  return (
    <div
      className="bg-center bg-no-repeat bg-cover bg-[#000000] w-full flex justify-center items-center "
      id="game_screen"
      style={{
        alignItems: 'center',
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'translateZ(0)',
        transformStyle: 'preserve-3d',
        zIndex: 1,
      }}
    >
      <div
        className={` z-10 bg-[#142C37] h-[640px] w-[360px] relative overflow-hidden`}
        style={{
          visibility: 'visible',
          flex: '0 0 auto',
        }}
        id="game_canvas"
      >
        {screen?.type === 'LEAD_SCREEN' ? (
          <LeadScreen
            score={0}
            leadScreen={screen}
            onSetScreen={onSetScreen}
            gameId={gameId}
          />
        ) : (
          <ElementsPreview elements={screen?.elements || []} />
        )}
      </div>
    </div>
  );
};

export default GameScreen;
